import { Injectable } from '@angular/core';

/**
 * Requests Provider
 *
 * Ce service permet d'effectuer toutes les rêquetes http (get,post,put,delete) avec une posisibilité de gérer un mode hors-ligne
 */
@Injectable({
  providedIn: 'root',
})
export class AngularFireStorage {
  upload(s: string, blob: Blob) {
    // TODO: to implement
    console.log('TODO: to implement');
  }
}
